import { render, staticRenderFns } from "./CliPL.vue?vue&type=template&id=0bc041eb"
import script from "./CliPL.vue?vue&type=script&lang=js"
export * from "./CliPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports